export { default } from './ArtistIdentityPreview';
